<template>
  <div class="function function-first" id="trade">
    <h5>交易管理</h5>
    <div class="function-detail">
      <ul>
        <router-link tag="li" to="/sell_goods">
          <i class="iconfont">&#xe64b;</i>
          <p>在售商品</p>
        </router-link>
        <router-link tag="li" to="/not_pass">
          <i class="iconfont">&#xe6d0;</i>
          <p>未通过商品</p>
        </router-link>
        <router-link tag="li" to="/order_form">
          <i class="iconfont">&#xe609;</i>
          <p>采购订单</p>
        </router-link>
        <router-link tag="li" to="/selled_goods">
          <i class="iconfont">&#xe626;</i>
          <p>已售商品</p>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeTrade'
}
</script>

<style scoped>
.function-detail ul{ display: flex; border-bottom: 12px solid #f1f1f1; font-size: 14px;}
.function h5{ margin: 10px 17px; font-size: 14px; font-weight: bold; font-family: 'Arial,Microsoft YaHei';}
.function-detail{ text-align: center;}
.function-detail .iconfont{ font-size: 25px;}
.function-detail p{ margin-top: 3px; color: #7e7979;}
.function-detail li{ margin-bottom: 10px; list-style-type: none; width: 25%;}
.function-first .iconfont{ color: #ec5c8d;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Trade.vue